import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import switchRegion from 'lib/geo/switchRegion'
import config from 'constants/config'

function useLoyaltyChooseDoubleRewardsRegion() {
  const intl = useIntl()
  const loggedIn = useAppSelector(selectLoggedIn)
  const region = useAppSelector(state => state.loyalty.account.data?.region)
  const currency = config.regions.find(item => item.code === region)?.currencyCode
  const isInLoyaltyRegion = useAppSelector(getIsCurrentRegionUserLoyaltyRegion)
  const needsRegionSwitch = loggedIn && !!region && !isInLoyaltyRegion
  const switchToLoyaltyRegion = useCallback(() => {
    if (region) switchRegion(region)
  }, [region])

  const switchRegionLabel = currency ? intl.formatMessage({
    id: 'y4ays9jzsAuR2W_Lbgr_',
    defaultMessage: 'Switch to {currency}',
    description: 'Action to switch to the membership currency for the double rewards campaign',
  }, { currency }) : intl.formatMessage({
    id: '2vEDQuo_xOCKeiUfi-bT',
    defaultMessage: 'Switch region',
    description: 'Action to switch to the membership region for the double rewards campaign',
  })

  return { needsRegionSwitch, switchToLoyaltyRegion, switchRegionLabel, currency }
}

export default useLoyaltyChooseDoubleRewardsRegion
